// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import SpotOutline from '../_raw/ui/icon_spot_outline.svg';
import withIconProps from '../withIconProps';

export default withIconProps(SpotOutline);
